// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"d9e96f6a","483":"8a46e17e"}[chunkId] + ".chunk.js";
};